export function normalizeURL(input, _temp) {
  var {
    defaultProtocol = 'http'
  } = _temp === void 0 ? {} : _temp;

  if (typeof input != 'string') {
    return undefined;
  }

  var inputString = input.trim();

  if (inputString.length === 0) {
    return undefined;
  } // Relative protocol "//foo.bar"


  if (inputString.startsWith('//')) {
    inputString = defaultProtocol + ":" + inputString;
  } // Without protocol "foo.bar"
  else if (!/^\w+:\/\//.exec(inputString)) {
      inputString = defaultProtocol + "://" + inputString;
    }

  var url;

  try {
    url = new URL(inputString);
  } catch (_unused) {
    return inputString;
  }

  if (url.pathname) {
    url.pathname = url.pathname // Remove extra slashes
    .replace(/([^/]:\/\/)|(\/)+/g, '$1$2');
  }

  return url.toString();
}